export const MIC_CONFIG = {
  source: 'GW' // 正式：boegw  测试：GW
}